import { render, staticRenderFns } from "./widget_curve_capital.vue?vue&type=template&id=2106d6ea&scoped=true&"
import script from "./widget_curve_capital.vue?vue&type=script&lang=js&"
export * from "./widget_curve_capital.vue?vue&type=script&lang=js&"
import style0 from "./widget_curve_capital.vue?vue&type=style&index=0&id=2106d6ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2106d6ea",
  null
  
)

export default component.exports